import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { trackZoomSetupFlow } from '../../../../util/trackingHelper';

import AddAVirtualEventButton from './AddAVirtualEventButton';

const mapDispatchToProps = () => ({
  onClick: () => {
    trackZoomSetupFlow('Flow Started', { flow_step_count: 2 });
    browserHistory.push('/wedding/manage/virtual/connect');
  },
});

export default connect(null, mapDispatchToProps)(AddAVirtualEventButton);



// WEBPACK FOOTER //
// ./src/components/manage/common/AddAVirtualEventButton/index.js